import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CircularProgressBar from 'components/CircularProgressBar';
import LinearProgressBar from 'components/LinearProgressBar';
import Button from 'components/Button';
import VolumeSeeker from 'components/VolumeSeeker';
import Text from 'components/Text';
import Title from 'components/Title';
import Icon from 'components/Icon';
import { TranslateMapContext } from 'contexts/TranslateMapContext';

import playIcon from 'assets/icons/play.svg';
import closeIcon from 'assets/icons/close.svg';

import {
  AdSkinStyled,
  TextWrap,
  TitleWrap,
  LeftPart,
  CloseButton,
  BottomWrapper,
  CenterPart,
  ClickWrapper,
  ResumeIconWrap,
  ResumeWrapper,
  SkinWrapper,
  TopCounterWrap,
  TopTitleWrap,
  TopWrapper,
  TopLeftPart,
  RightPart,
  PointerEventsAll,
} from './styles/AdSkinStyled';

class AdSkin extends PureComponent {
  static contextType = TranslateMapContext;

  constructor(props) {
    super(props);
    this.progressState = 0;
  }

  handleResume = () => {
    const { resume } = this.props;

    resume();
  };

  handlePauseMessage = () => {
    const { clickMessage, url } = this.props;

    // handlePauseChange(true);
    // TODO: check nessecity of this
    clickMessage(url);
  };

  handleAdClick = () => {
    const { clickOnBg, url } = this.props;

    // handlePauseChange(true);
    clickOnBg(url);
  };

  // method for fixing processing of negative progress values
  parseProgress = () => {
    const { progress } = this.props;
    let result;
    if (!this.progressState && progress) {
      this.progressState = progress;
      result = 0;
    } else {
      result = progress - this.progressState;
    }
    return result;
  };

  skipAd = () => {
    const { skip, skipLeft } = this.props;
    if (skipLeft < 1) {
      skip();
    }
  };

  render() {
    const {
      close,
      mute,
      unMute,
      setVolume,
      muted,
      volume,
      paused,
      progressVisible,
      skipTime2,
      duration,
      currentTime,
      skipButton,
      isSkipDisabled,
      skipLeft,
      url,
      isTitleVisible,
      titleTxt,
      controls,
      isImageMediaFile,
      isMobile,
      isVPAID,
      isClickable,
      translate,
      isImaAd,
      count,
      number,
      isSmallMode,
    } = this.props;
    const translateKeys = this.context;

    let { linkTxt } = this.props;

    const counterText = translate(translateKeys.advAdditionalPart, {
      number,
      count,
    });
    let disableClicks = (isImaAd && !paused) || (!controls && !paused);
    let isCloseButtonShow;

    if (!isClickable && isVPAID) disableClicks = true;

    const skipText = isSkipDisabled
      ? `${translate(translateKeys.skipAds)} ${translate(
          translateKeys.through
        )} ${skipLeft} ${translate(translateKeys.second)}`
      : translate(translateKeys.skipAds);

    let title = (
      <Title
        font="din_medium"
        color="white"
        fixedSize
        size={isMobile ? 'fs_s' : 'fs_md'}
      >
        {translate(translateKeys.advTitle)}
      </Title>
    );
    let renderBottomWrap = true;
    if (isVPAID && controls && !isClickable) {
      renderBottomWrap = false;
    }

    if (titleTxt) {
      title = (
        <Title font="din_medium" color="white">
          {titleTxt}
        </Title>
      );
    }

    if (linkTxt === '') {
      linkTxt = translate(translateKeys.goToTheAdvWebsite);
    }

    if (skipTime2 !== undefined) {
      isCloseButtonShow =
        skipTime2 >= 0 &&
        skipTime2 < duration &&
        currentTime > skipTime2 &&
        !paused;
    }

    return (
      <AdSkinStyled
        isMobile={isMobile}
        disableClicks={disableClicks && !isClickable}
      >
        {paused && (
          <ResumeWrapper onClick={this.handleResume}>
            <ResumeIconWrap>
              <Icon name={playIcon} size={24} />
            </ResumeIconWrap>
          </ResumeWrapper>
        )}
        <SkinWrapper>
          {isClickable && !paused && (
            <ClickWrapper onClick={this.handleAdClick} />
          )}
          {controls && !isSmallMode && (
            <TopWrapper>
              <TopLeftPart>
                <TopTitleWrap>{isTitleVisible && title}</TopTitleWrap>
                {count > 1 && isTitleVisible && (
                  <TopCounterWrap>
                    <Text
                      color="white"
                      fixedSize
                      size={isMobile ? 'fs_xxs' : 'fs_xs'}
                    >
                      {counterText}
                    </Text>
                  </TopCounterWrap>
                )}
              </TopLeftPart>
            </TopWrapper>
          )}
          {controls && renderBottomWrap && (
            <BottomWrapper>
              <LeftPart>
                {!isImageMediaFile && (
                  <VolumeSeeker
                    mute={mute}
                    unMute={unMute}
                    setVolume={setVolume}
                    muted={muted}
                    volume={volume}
                    isMobile={isMobile}
                  />
                )}
              </LeftPart>
              {!isSmallMode && (
                <CenterPart>
                  {isClickable && (
                    <PointerEventsAll>
                      <TitleWrap justLink={isClickable && !skipButton}>
                        <Button
                          disable={!url}
                          onClick={this.handlePauseMessage}
                          textColor="white"
                          textSize={isMobile ? 'fs_xs' : 'fs_l'}
                          isMobile={isMobile}
                          text={linkTxt}
                        />
                      </TitleWrap>
                    </PointerEventsAll>
                  )}
                  {skipButton && (
                    <PointerEventsAll>
                      <TextWrap>
                        <Button
                          disable={isSkipDisabled}
                          onClick={this.skipAd}
                          textSize={isMobile ? 'fs_xxs_' : 'fs_s'}
                          textColor="gray_smokegray"
                          isMobile={isMobile}
                          text={skipText}
                          textType={isMobile ? 'uppercase' : null}
                        />
                      </TextWrap>
                    </PointerEventsAll>
                  )}
                </CenterPart>
              )}
              {!isMobile && progressVisible && (
                <RightPart>
                  <CircularProgressBar
                    strokeWidth={2}
                    sqSize={22}
                    percentage={this.parseProgress()}
                  />
                </RightPart>
              )}
              {isMobile && progressVisible && (
                <LinearProgressBar
                  progress={this.parseProgress()}
                ></LinearProgressBar>
              )}
            </BottomWrapper>
          )}
        </SkinWrapper>
        {!isSmallMode && isCloseButtonShow && (
          <CloseButton
            onClick={close}
            icon={closeIcon}
            iconSize={24}
            isMobile={isMobile}
          />
        )}
      </AdSkinStyled>
    );
  }
}

AdSkin.propTypes = {
  // vastData: PropTypes.object.isRequired,
  skip: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  clickOnBg: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  clickMessage: PropTypes.func.isRequired,
  resume: PropTypes.func.isRequired,
  // pause: PropTypes.func.isRequired,
  mute: PropTypes.func.isRequired,
  unMute: PropTypes.func.isRequired,
  setVolume: PropTypes.func.isRequired,

  count: PropTypes.number.isRequired,
  number: PropTypes.number.isRequired,
  paused: PropTypes.bool.isRequired,
  volume: PropTypes.number.isRequired,
  muted: PropTypes.bool.isRequired,
  skipTime2: PropTypes.number,
  duration: PropTypes.number.isRequired,
  isClickable: PropTypes.bool.isRequired,
  currentTime: PropTypes.number.isRequired,
  skipButton: PropTypes.bool.isRequired,
  progress: PropTypes.number.isRequired,
  isSkipDisabled: PropTypes.bool.isRequired,
  skipLeft: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired,
  isTitleVisible: PropTypes.bool.isRequired,
  titleTxt: PropTypes.string.isRequired,
  linkTxt: PropTypes.string.isRequired,
  progressVisible: PropTypes.bool.isRequired,
  controls: PropTypes.bool.isRequired,
  isImageMediaFile: PropTypes.bool.isRequired,
  isVPAID: PropTypes.bool.isRequired,
  isImaAd: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  isSmallMode: PropTypes.bool.isRequired,
};

export default AdSkin;
